$(window).on("load", function () {

  $('.header-menu-btn').on('click',function(){
     $(".header-nav").css("display","unset");
     setTimeout(function(){
       $(this).toggleClass("open");
       $(".header-nav").toggleClass("header-nav-active");
       if($(".header-nav").hasClass("header-nav-active")){
            $(".header-nav").css("display","block");
        }
        else {
           $(".header-nav").css("display","none");
        }
     }, 400)
  })

  
  $("li:first-child").addClass("first");
  $("li:last-child").addClass("last");

  $('[href="#"]').attr("href", "javascript:;");

  $(".menu-Bar").click(function () {
    $(this).toggleClass("open");
    $(".menuWrap").toggleClass("open");
    $("body").toggleClass("ovr-hiddn");
  });


  $(".overlay").click(function () {
    $(".popup-delivery").fadeOut();
    $(".overlay").fadeOut();
  });


   $(".close-enquiry-popup,.overlay").click(function () {
    $(".enquiry-form-popup").fadeOut();
    $(".overlay").fadeOut();
  });

   $(".close-install,.overlay,.popup-install").click(function () {
    $(".popup-install").fadeOut();
    $(".overlay").fadeOut();
  });
  
  $(".closePop,.overlay").click(function () {
    $(".popupMain").fadeOut();
    $(".overlay").fadeOut();
  });


  /* Tabbing Function */
  $("[data-targetit]").on("click", function (e) {
    $(this).addClass("active");
    $(this).siblings().removeClass("active");
    var target = $(this).data("targetit");
    $("." + target)
      .siblings('[class^="box-"]')
      .hide();
    $("." + target).fadeIn();
    $(".tabViewList").slick("setPosition", 0);
  });



  $('.calc-quote-btn').on("click",function(){

  $(".get-quote-form-wrapper").fadeIn();
  $(".overlay").fadeIn();
    
  })
  $('.close-quote-solar').on("click",function(){

  $(".get-quote-form-wrapper").fadeOut();
  $(".overlay").fadeOut();
    
  })
  
  
  // Accordian
  $(".bulk-enquiry-faq-list h4").click(function () {
    $(".bulk-enquiry-faq-list li").removeClass("active");
    $(this).parent("li").addClass("active");
    $(".bulk-enquiry-faq-list li div").slideUp();
    $(this).parent("li").find("div").slideDown();
  });


  $(".index-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    autoplay:true,
    speed: 300,
    slidesToShow: 1,
    prevArrow: $(".hero-btn-left-wrap"),
    nextArrow: $(".hero-btn-right-wrap"),
  });

  
  $(".collection-banner-sliders").slick({
    dots: false,
    arrows: true,
    infinite: true,
    autoplay:true,
    speed: 300,
    slidesToShow: 1,
    prevArrow: $(".hero-btn-left-wrap"),
    nextArrow: $(".hero-btn-right-wrap"),
  });

  
  $(".deal-box-slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay:true,
    speed: 300,
    slidesToShow: 1,
  });

  $(".trending-products-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 600,
    autoplay:true,
    autoplaySpeed:5000,
    slidesToShow: 4,
    prevArrow:
      '<button class="trending-btn trending-left"><i class="fal fa-chevron-left"></i></button>',
    nextArrow:
      '<button class="trending-btn trending-right"><i class="fal fa-chevron-right"></i></button>',
     responsive: [
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: 4,
        }
      },
       {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
       {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots:true,
          slidesToScroll:2,
        }
      },
       ]
  });




 

  
  
  // $(".collection-page-subcats-list").slick({
  //   dots: false,
  //   arrows: true,
  //   infinite: true,
  //   speed: 600,
  //   autoplay:true,
  //   autoplaySpeed:5000,
  //   slidesToShow: 4,
  //   prevArrow:
  //     '<button class="trending-btn trending-left"><i class="fal fa-chevron-left"></i></button>',
  //   nextArrow:
  //     '<button class="trending-btn trending-right"><i class="fal fa-chevron-right"></i></button>',
  //    responsive: [
  //     {
  //       breakpoint: 1280,
  //       settings: {
  //         slidesToShow: 4,
  //       }
  //     },
  //      {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 2,
  //         dots:true,
  //         slidesToScroll:2,
  //       }
  //     },
  //      ]
  // });

  $(".home-listings-alt-slider").slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 600,
    autoplay:true,
    autoplaySpeed:5000,
    slidesToShow: 4,
    slidesToScroll:4,
    adaptiveHeight: true,
    prevArrow:
      '<button class="hla-listing-btn hla-listing-left"><i class="fal fa-chevron-left"></i></button>',
    nextArrow:
      '<button class="hla-listing-btn hla-listing-right"><i class="fal fa-chevron-right"></i></button>',
     responsive: [
      {
        breakpoint: 1550,
        settings: {
          slidesToShow:4,
        }
      },
       {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
        {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots:true,
          slidesToScroll:2,
        }
      },
       ]
  });


  $(".home-listings-product").slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 600,
    autoplay:true,
    autoplaySpeed:5000,
    slidesToShow: 4,
    slidesToScroll:3,
    adaptiveHeight: true,
    prevArrow:
      '<button class="hla-listing-btn hlap-listing-left"><i class="fal fa-chevron-left"></i></button>',
    nextArrow:
      '<button class="hla-listing-btn hlap-listing-right"><i class="fal fa-chevron-right"></i></button>',
     responsive: [
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: 4,
        }
      },
        {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots:true,
          slidesToScroll:2,
        }
      },
       ]
  });

  //     Slider For
  // $('.slider-for').slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     dots: false,
  //     arrows: false,
  //     fade: true,
  //     asNavFor: '.slider-nav'
  // });
  // $('.slider-nav').slick({
  //     slidesToShow: 4,
  //     slidesToScroll: 1,
  //     asNavFor: '.slider-for',
  //     dots: false,
  //     focusOnSelect: true
  // });

  /* Top Scroll */
  // $('body').on('click', '.scrolldown-fl', function() {
  //     goToScroll('awardSec');
  // });
});

// $(window).on("scroll touchmove", function() {
//     $("header").toggleClass("stickyOpen", $(document).scrollTop() > 200);
// });



var login_btn = $('.header-login-btn');
var info_banners = $('.assistance-section-home');
var header_search = $('.header-search-wrap');

var category_title = $('.custom-product-collection-title');
/* RESPONSIVE JS */
if ($(window).width() < 767) {


  $('.hi-bar-right').append(login_btn);

  $('.tw-top').append(info_banners)
  
  $('.collections-products-page-ph').prepend(category_title);

  
  $('.section-header').append(header_search)


  
   $(".home-info-box-wraps .row").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
     
  });

  //  $(".home-listings-product").slick({
  //   dots: true,
  //   arrows: false,
  //   infinite: true,
  //   speed: 600,
  //   slidesToShow: 1,
  //    variableWidth:true,
  // });


  $(".footer-accordian").on("click", function () {
    $(this).toggleClass("active");
    $(this).next().slideToggle();
  });



   $(".alternate-products-list").slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll:1,
  
  });

  
   $(".promos-section .row").slick({
    dots: true,
    arrows: false,
    infinite: false,
     autoplay:true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll:1,
  
  });


  $(".home-decor-products-list").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 600,
    autoplay:true,
    autoplaySpeed:3000,
    slidesToShow: 2,
    slidesToScroll:2,
    prevArrow:
      '<button class="hla-listing-btn hlap-listing-left"><i class="fal fa-chevron-left"></i></button>',
    nextArrow:
      '<button class="hla-listing-btn hlap-listing-right"><i class="fal fa-chevron-right"></i></button>',
  });


    $(".parent-has-child").append(

        "<span class='mob-drop'><i class='fal fa-plus'></i></span>"

    );

  
    $(".header-nav").append(

        "<span class='mobile-menu-close'><i class='fal fa-times'></i></span>"

    );


   $(".mob-drop").on("click",function() {


            $(this).toggleClass("mob-active");

            $(this).prev().slideToggle();

   });


  $('.mobile-menu-close').on("click",function() {
     $(".header-nav").css("display", "unset");
     setTimeout(function(){
       $(".header-nav").toggleClass("header-nav-active");
       if($(".header-nav").hasClass("header-nav-active")){
            $(".header-nav").css("display","block");
        }
        else {
           $(".header-nav").css("display","none");
        }
     }, 400)
   });


  
  
}



function goToScroll(e) {
  $("html, body").animate(
    {
      scrollTop: $("." + e).offset().top,
    },
    1000
  );
}


  site_header = $('.express-header');
  header_class = 'express-header';
  
  $(window).scroll(function(){
        scroll = $(window).scrollTop();
        // get the height again cuz is getting 0 idk why
        header_height = document.getElementsByClassName(header_class)[0].clientHeight;
        if (scroll >= 350) {
          site_header.css('position', 'fixed');
           site_header.css('boxShadow', '1px 1px 7px #0006');
          site_header.addClass('header-sticky');

          if ($(window).width() > 767) {
              $('.main-header-menu').show();
          }
        }
        else {
          site_header.css('position', 'relative');
           site_header.css('boxShadow', 'none');
          site_header.removeClass('header-sticky');
          if ($(window).width() > 767) {
              $('.main-header-menu').hide();
          }
        } 

  });


//enquiry popup 


$('.pbm-btn-enquiry').on('click',function(){

  console.log("PBM BTN ENQUIRY")

  var enquiryTitle =$(this).attr("data-enquiry");
  console.log(enquiryTitle);
  
  $('.field-input-product').val(enquiryTitle);


  $(".enquiry-fp").fadeIn();
  $(".overlay").fadeIn();

  
})


$('#mpi-bulk-enquiry').on('click',function(){


  var enquiryTitle =$(this).attr("data-enquiry");
  console.log(enquiryTitle);
  
  $('.enquiry-form-bulk .field-input-product').val(enquiryTitle);


  $(".enquiry-form-bulk").fadeIn();
  $(".overlay").fadeIn();

  
})



//Header close outside click
const target = document.querySelector(".express-header");

document.addEventListener("click", (event) => {
  const withinBoundaries = event.composedPath().includes(target);

  if (withinBoundaries) {
    console.log("Click happened inside element");
    // target.innerText =
  } else {

  $('.header-menu-btn').removeClass("open");
  $(".header-nav").removeClass("header-nav-active");
  setTimeout(function(){
       $(".header-nav").css("display", "none"); 
   }, 400)
    
    console.log("Click happened **OUTSIDE** element");
    // target.innerText =
  }
});




var lazyLoadInstance = new LazyLoad({
  // Your custom settings go here
});


// document.addEventListener('contextmenu', event => event.preventDefault());



if ($(window).width() < 825) {
  $(".home-listing-slider ul").slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay:true,
    speed: 300,
    rows:2,
    slidesToShow: 4,
    slidesToScroll: 1
  });
}

